export class Iframe {
  constructor(difference) {
    this.styleId = 1
    this.width = 500
    this.widthType = "px"
    this.height = 300
    this.heightType = "px"
    this.top = 10
    this.left = 10
    this.iframeUrl = ""
    this.rotate = 0
    this.innerElement = "cxIframe"
    this.iframeScrollStatus = false
    this.bgColor = "#FFFFFF"
    this.bgIsThemeColor = false
    this.background = []
    this.showBorder = false
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderTopRightRadius = 0
    this.borderTopLeftRadius = 0
    this.borderWidth = 0
    this.borderColor = "#3D82F2"
    this.borderStyle = "solid"
    this.borderIsThemeColor = false
    this.usePageQuery = false //页面传参
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
